export default {"src":"/_next/static/media/envelope.8c925166.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};